class PdpTab extends HTMLElement {
  connectedCallback() {
    this.pdpTabsSection = this.closest('section');
    this.sectionToScrollTo = this.targetSection ?? getNthSibling(this.pdpTabsSection, Number(this.dataset.index));
    if (!this.sectionToScrollTo) return;

    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.classList.add('pdp-tabs__button');
    this.button.textContent = this.dataset.title;
    this.append(this.button);

    // Active state while the section sits right under the sticky tabs
    const sectionHeight = this.pdpTabsSection.offsetHeight;
    const bottomRootMargin = window.visualViewport.height - sectionHeight - 1;
    const observer = new IntersectionObserver(this.observerCallback, {
      threshold: 0,
      rootMargin: `-${sectionHeight + 1}px 0px -${bottomRootMargin}px 0px`,
    });
    observer.observe(this.sectionToScrollTo);

    this.sectionToScrollTo.style.scrollMarginTop = `${sectionHeight}px`;
    this.button.addEventListener('click', () => this.sectionToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  }

  observerCallback = (entries) => {
    entries.forEach(({ isIntersecting }) => this.button.classList.toggle('pdp-tabs__button--active', isIntersecting));
  };
}

// Fallback for tabs rendered with data-index only (skips empty sections)
function getNthSibling(element, targetIndex) {
  let sibling = element;
  let index = -1;

  while (index < targetIndex) {
    sibling = sibling?.nextElementSibling;
    if (!sibling) return null;
    if (!sibling.querySelector('.pdp-empty-section')) index += 1;
  }

  return sibling;
}

customElements.define('pdp-tab', PdpTab);